import React, { Fragment, useState, useRef, useEffect } from "react";
import CustomLoader from "../../customLoader/CustomLoader";
import GetAdminService from "../../../services/admin/GetAdminService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import CustomPagination from "../../pagination/Pagination";
import AddSchoolIt from "./AddSchoolIt";
import "../AdminPages.css";

const Recruiters = () => {
  const [schoolName, setSchoolName] = useState();
  const [pageData, setPageData] = useState();
  const [showSchoolNameContainer, setShowSchoolNameContainer] = useState(false);
  const [openModifyRecruiter, setOpenModifyRecruiter] = useState(false);
  const [page, setPage] = useState(1);
  const [schoolNameList, setSchoolNameList] = useState();
  const schoolNameRef = useRef();
  const timeoutRef = useRef();
  const fetchSeqRef = useRef(0);
  const [showRecruiter, setShowRecruiter] = useState(false);
  const [openRecruiter, setOpenRecruiter] = useState(false);
  const [collegeId, setCollegeId] = useState();
  const [loading, setLoading] = useState(false);
  const [modifyData, setModifyData] = useState({});
  const [modifyRecruiterIndex, setRecruiterIndex] = useState();
  const [schoolNameLoading, setSchoolNameLoading] = useState(false);

  const getSchoolsList = (value) => {
    setSchoolNameLoading(true);
    GetAdminService.getSchoolsList(value)
      .then((data) => {
        setSchoolNameList(data?.data?.school);
        setSchoolNameLoading(false);
        setShowSchoolNameContainer(true);
      })
      .catch(() => {
        setSchoolNameLoading(false);
      });
  };

  const handleCollegeName = () => {
    clearTimeout(timeoutRef.current);
    setSchoolName(schoolNameRef.current.value);
    if (!schoolNameRef.current.value) {
      setShowSchoolNameContainer(false);
      setSchoolNameList([]);
      setPageData();
      setCollegeId();
      setShowRecruiter(false);
    } else {
      timeoutRef.current = setTimeout(() => {
        getSchoolsList(schoolNameRef.current.value);
      }, 1000);
    }
  };

  const handleSelectedCollegeName = (item) => {
    setSchoolNameList([item]);
    setShowSchoolNameContainer(false);
    setShowRecruiter(true);
    setSchoolName(item.name);
    setPage(1);
    setCollegeId(item?.id);
  };

  const getRecruiterwithId = (id, pageNum = page) => {
    if (!id) return;
    const seq = ++fetchSeqRef.current;
    setLoading(true);
    let obj = {
      school: id,
      page: pageNum,
      role: "school_it",
    };
    GetAdminService.getAdminSchoolIT(obj)
      .then((data) => {
        if (seq !== fetchSeqRef.current) return;
        setPageData(data?.data);
        setLoading(false);
      })
      .catch(() => {
        if (seq !== fetchSeqRef.current) return;
        setLoading(false);
      });
  };

  const handleSelectedRecruiter = (item, index) => {
    setModifyData(item);
    setRecruiterIndex(index);
    setOpenModifyRecruiter(true);
  };

  const handlePageChange = (nextPage) => {
    if (nextPage === page) return;
    setPage(nextPage);
  };

  useEffect(() => {
    if (collegeId) {
      getRecruiterwithId(collegeId, page);
    }
  }, [page, collegeId]);

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="csv-import-container">
            <div className="admin-students-page-header">
              <h2>Create School IT</h2>
              {showRecruiter && (
                <button
                  onClick={() => setOpenRecruiter(true)}
                  className="admin-students-new-btn"
                >
                  <FontAwesomeIcon icon={faUser} />
                  New School IT
                </button>
              )}
            </div>

            <div className="admin-students-school-selector">
              <label>Select School</label>
              <div className="school-input-wrapper">
                <input
                  ref={schoolNameRef}
                  type="text"
                  placeholder="Type to search school name..."
                  value={schoolName}
                  onChange={handleCollegeName}
                  autoComplete="off"
                />
                {showSchoolNameContainer && (
                  <ul className="school-dropdown">
                    {schoolNameLoading && <CustomLoader />}
                    {schoolNameList?.length > 0 &&
                      schoolNameList.map((item, index) => (
                        <li
                          onClick={() => handleSelectedCollegeName(item)}
                          key={index}
                        >
                          {item.name}
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            </div>

            <div className="admin-students-list-section">
              <div className="admin-student-list-container">
                {loading ? (
                  <CustomLoader />
                ) : (
                  pageData?.result?.length > 0 && (
                    <>
                      <p className="admin-students-heading">School IT</p>
                      {pageData.result.map((item, index) => (
                        <div
                          key={item?.id || index}
                          className={`student-list ${
                            index === modifyRecruiterIndex
                              ? "student-list-active"
                              : ""
                          }`}
                          onClick={() => handleSelectedRecruiter(item, index)}
                        >
                          <span className="student-email">{item.email}</span>
                        </div>
                      ))}
                    </>
                  )
                )}
              </div>
              {pageData && pageData?.page_list?.length > 1 && (
                <div className="admin-page-pagination">
                  <CustomPagination
                    count={pageData}
                    pageValue={page}
                    setPage={handlePageChange}
                  />
                </div>
              )}
            </div>

            {openRecruiter && (
              <AddSchoolIt
                setOpenRecruiter={setOpenRecruiter}
                modify={false}
                school_id={collegeId}
                recruiterCall={getRecruiterwithId}
              />
            )}
            {openModifyRecruiter && (
              <AddSchoolIt
                setOpenRecruiter={setOpenModifyRecruiter}
                modify={modifyData}
                school_id={collegeId}
                recruiterCall={getRecruiterwithId}
              />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Recruiters;
